import { Link } from '@remix-run/react'
import { Stack } from '~/components-v2/stack/stack'

import DatabricksIcon from '~/components/illustration/databases/databricks.svg?react'

export const flashActive = true

export const FlashContent = () => (
  <Stack row gap={2} align="center">
    <strong>
      Meet us at <Link to="/databricks">Databricks Data + AI Summit</Link>{' '}
    </strong>
    <DatabricksIcon style={{ height: '1rem', width: '1rem' }} />
  </Stack>
)
